import type { JSX } from 'react';
import { type FieldValues } from 'react-hook-form';

import type { FormFieldProps } from '~/chords/FormField';
import { FormFieldInput as ChordsFormFieldInput } from '~/chords/FormField';
import { type InputProps } from '~/chords/Input';
import type { ContainerComponentProps } from '~/components/WithClassNameHoc';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

type FormFieldInputProps<TFormFields extends FieldValues> = Omit<
  FormFieldProps<TFormFields>,
  'children'
> &
  Omit<InputProps, 'name' | 'className'> & {
    /**
     * When true, converts the input value to a number before setting it on the form.
     * Useful for number inputs where you want the form value to be a number, not a string.
     */
    valueAsNumber?: boolean;
  };

export const FormFieldInput = withClassNameHoc(ChordsFormFieldInput) as <
  TFormFields extends FieldValues,
>(
  props: ContainerComponentProps<FormFieldInputProps<TFormFields>>,
) => JSX.Element;
